import Collect from './Collect'

export default Collect
